import { ILocalizationKeys } from "./constant";

const en: ILocalizationKeys = {
  welcome: "Welcome",
  youAlreadyHaveAnAccount: "You already have an account",
  login: "Log in",
  wouldYouLikeToCreateAnAccount: "Would you like to create an account",
  register: "Register",
  orSimplyPlayWithoutRegistration: "or simply play without registration",
  youCanRegisterAtAnyTimeLater: "You can register at any time later",
  playInstantly: "Play Instantly",
  emailValidation: "Please enter a valid email address!",
  passwordValidation: "Please enter a valid password!",
  email: "Email",
  password: "Password",
  forgotPassword: "Forgot password",
  continueWithGoogle: "Continue with Google",
  or: "or",
  newAccount: "New account",
  continueWithEmail: "Continue with E-mail",
  registerWithEmail: "Register with E-mail",
  repeatPassword: "Repeat Password",
  pleaseFillOutTheFieldsToRegister: "Please fill in the fields to register!",
  passwordNotMatch: `Passwords do not match!`,
  confirmPassword: "A password is required to confirm!",
  createAnAccount: " Create an account",
  submit: "Submit",
  deleteAccount: "Delete Account",
  crossword: "Swedish Puzzle",
  gridPuzzle: "Grid Puzzle",
  sudoku: "Sudoku",
  wordSearch: "Word Search",
  dailyPuzzle: "Easy Daily Puzzles",
  easyPuzzle: "Easy Puzzles",
  enterTheCodeHere: "Enter the code here:",
  redeemPromoCode: "Redeem Promo Code",
  redeem: "Redeem",
  promoCodeValidation: "Please enter a valid code!",
  starterPackage: "Starter Package!",
  bestSellingOffer: "Best Selling Offer!",
  saveFoxOffer: "Save Fox Offer!",
  joker: "Joker",
  freeHints: "Free Hints",
  allThreeHoursHints: "All 3 hours free hints!",
  collect: "Collect",
  yes: "Yes",
  deleteAccountTitle: "Are you sure you want to delete your account?",
  continueWithApple: "Continue with Apple",
  timeSoFar: "Time so far",
  jokerAvailable: "Joker available",
  jokerDescription:
    "Use joker at any time to master tricky spots and gain time",
  backToLobby: "To the lobby",
  start: "Start",
  intermediatePuzzles: "Intermediate Puzzles",
  hardPuzzles: "Hard Puzzles",
  proPuzzles: "Pro Puzzles",
  fullPage: "Full page",
  doublePage: "Double Page",
  picturePuzzle: "Picture Puzzles",
  showMoreLevels: "Show More Levels",
  showLessLevels: "Show Less Levels",
  doYouLikeRateFuchs: "Do you like Rate-Fuchs?",
  rateNow: "Rate now",
  thankYouForYourFeedback: "Thank you for your feedback",
  gameOver: "Verloren",
  youMadeMistakesAndEndedTheGame:
    "Du hast 3 Fehler gemacht und das Spiel beendet",
  secondChance: "Neu starten",
  restart: "Neu starten",
  timeRequired: "Time required",
  mistake: "Mistake",
  solved: "Solved",
  done: "Done!",
  thePuzzle: "The puzzle",
  isComplete: "is complete!",
  help: "Help",
  currentBalance: "Current balance",
  sound: "Sound",
  logout: "Logout",
  feedback: "Feedback",
  language: "Language",
  smallCrosswordChest: "Small Crossword Chest",
  mediumCrosswordChest: "Medium Crossword Chest",
  bigCrosswordChest: "Big Crossword Chest",
  hugeCrosswordChest: "Huge Crossword Chest",
  smallCrosswordDescription: "Contains 8 solution letters for Crossword",
  mediumCrosswordDescription: "Contains 16 solution letters for Crossword",
  bigCrosswordDescription: "Contains 32 solution letters for Crossword",
  hugeCrosswordDescription: "Contains 48 solution letters for Crossword",
  smallGridPuzzleChest: "Small Grid Puzzle Chest",
  mediumGridPuzzleChest: "Medium Grid Puzzle Chest",
  bigGridPuzzleChest: "Big Grid Puzzle Chest",
  smallGridPuzzleDescription: "Contains 6 solution letters for Grid puzzle",
  mediumGridPuzzleDescription: "Contains 10 solution letters for Grid puzzle",
  bigGridPuzzleDescription: "Contains 18 solution letters for Grid puzzle",
  smallSudokuChest: "Small Sudoku Chest",
  mediumSudokuChest: "Medium Sudoku Chest",
  bigSudokuChest: "Big Sudoku Chest",
  smallSudokuDescription: "Contains 4 solution letters for Sudoku",
  mediumSudokuDescription: "Contains 8 solution letters for Sudoku",
  bigSudokuDescription: "Contains 12 solution letters for Sudoku",
  smallWordSearchChest: "Small Word Search Chest",
  mediumWordSearchChest: "Medium Word Search Chest",
  bigWordSearchChest: "Big Word Search Chest",
  smallWordSearchDescription: "Contains 4 solution letters for Word search",
  mediumWordSearchDescription: "Contains 8 solution letters for Word search",
  bigWordSearchDescription: "Contains 14 solution letters for Word search",
  note: "Note",
  chestDescription:
    "Open a vocabulary chest in any puzzle and automatically receive joker letters, so you can solve puzzles more easily and quickly",
  showMore: "Show More",
  showLess: "Show Less",
  chooseYourAvatar: "Choose your avatar",
  userValidation: "Name is required!",
  feedbackFormValidation: "Message is required!",
  whatCanWeImprove: "What can we improve?",
  youOpinionIsImportantToUs: "Your opinion is important to us:",
  gameIsUpdated: "Game is updated",
  gameLobbyDescription:
    "Read the clues and fill the appropriate words into the grid by clicking on a square. Words cross horizontally and vertically. Solve the puzzle by identifying and filling in the remaining words",
  swipeLeftOrRightToSelectCrosswordOrSudokuPuzzle:
    "Swipe left or right to select crossword or sudoku puzzle.",
  hintButtonDescription:
    "Tap this button to open the hint shop.Here you can stock up on new hints to help you in puzzles.",
  helpSettingDescription:
    "Tapping this icon open the settings. Here you can turn sounds on or off, register,and view additional info.",
  unlockNow: "Unlock Now?",
  purchaseCost: "The purchase costs 10 Joker",
  cancel: "Cancel",
  okay: "Okay",
  requiredPurchasePuzzle: "10 Joker required for purchase",
  goToShop: "Go to shop",
  new: "New",
  size: "Size",
  totalWords: "Total words",
  wordsCorrect: "Words correct",
  dataProtection: "Data protection",
  imprint: "Imprint",
  justForFun: "Just4Fun GmbH",
  allRightReserved: "All Rights Reserved.",
  loginTitle: "Log in",
  youAreNotRegisterSoPleaseRegisterFirst:
    "You are not register,so please register first",
  invalidLoginCredentials: "Invalid login credentials",
  passwordDescription:
    "Passwords must consist of at least 8 characters and contain both letters and characters!",
  rememberMe: "Remember me",
  youAreAlreadyRegister: "You are already register",
  registerViaEMail: "Register with email",
  sendTheEmailSuccessfully: "Email sent successfully",
  userIsNotExists: "User is not exists",
  reload: "Reload",
  partnerShip: "Partnerships",
  save: "Save",
  usernameUpdatedSuccessfully: "Username updated successfully",
  agb: "Terms and Conditions",
  feedbackIsSendedSuccessfully: "Feedback submitted successfully",
  userAvatarIsUpdatedSuccessfully: "User avatar is updated successfully",
  jokersAreSuccessfullySended: "Jokers are successfully sended",
  successfullyPurchase: "Successfully Purchase",
};

export default en;
